import { FunctionComponent, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { StoreFont, StoreSpecialFont } from '@/types';
import { t } from '@/utils/i18n';
import {
  getFontPreviewBackgroundPosition,
  getFontPreviewUrl,
} from '@/utils/imageUrls/getFontPreviewUrl';
import { isStoreFont } from '@/model/font/isFontType';
import { getFonts } from '@/redux/core/getters/getFonts';
import { CaretRight } from '@/components/common/icons/Caret';
import './FontSelector.scss';

interface FontSelectorProps {
  selectedFont: StoreFont | StoreSpecialFont;
  onClick: () => void;
}

export const FontSelector: FunctionComponent<FontSelectorProps> = ({ selectedFont, onClick }) => {
  const fonts = useSelector(getFonts);
  const fontPreview = useMemo(() => getFontPreviewUrl(fonts.map(({ id }) => id)), [fonts]);
  if (isStoreFont(selectedFont)) {
    const fontIndex = fonts.findIndex((f) => f.id === selectedFont.familyId);

    return (
      <button
        type="button"
        title={t('textSettings.font')}
        className="font-selector"
        onClick={onClick}
        style={{
          backgroundImage: `url(${fontPreview})`,
          backgroundPosition: `center ${getFontPreviewBackgroundPosition(fonts.length, fontIndex)}`,
        }}
      >
        <span className="sr-only">
          {selectedFont.name} {t('textSettings.font')}
        </span>
        <CaretRight />
      </button>
    );
  }

  return (
    <button
      type="button"
      title={t('textSettings.font')}
      className="font-selector"
      onClick={onClick}
    >
      <img src={selectedFont.icon} alt="" />
      {selectedFont.title}
      <span className="sr-only">{t('textSettings.font')}</span>
      <CaretRight />
    </button>
  );
};
